import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: false
  },
  mutations: {
    setDrawer: (state, val) => {
      state.drawer = val
    }
  },
  actions: {

  },
  getters: {
    getNavbarState: (state) => {
      return state.drawer;
    }
  }
})
